// extracted by mini-css-extract-plugin
module.exports = {"message":"Tooltips_message_1ON_k","boldMessage":"Tooltips_boldMessage_1XQCq","progressText":"Tooltips_progressText_ro7WI","needResource":"Tooltips_needResource_2XNRo"};